export enum EDetailPageTopBarItemType {
  iconButton,
  button,
  loadingButton,
  tagView,
  text,
}
